// extracted by mini-css-extract-plugin
export default {"dots":"style_dots__Ta0jO"};